export const NAME_UPDATE_REQUEST = 'NAME_UPDATE_REQUEST'
export const NAME_UPDATE_SUCCESS = 'NAME_UPDATE_SUCCESS'
export const NAME_UPDATE_FAILURE = 'NAME_UPDATE_FAILURE'
export const NAME_DETAIL_REQUEST = 'NAME_DETAIL_REQUEST'
export const NAME_DETAIL_SUCCESS = 'NAME_DETAIL_SUCCESS'
export const NAME_DETAIL_FAILURE = 'NAME_DETAIL_FAILURE'